/* eslint-disable import/prefer-default-export */
export const urls = {
  AUTECO_HOME: 'https://www.autecomobility.com/',
  AUTECO_HABEAS_DATA:
    'https://www.autecomobility.com/manual-de-politicas-y-procedimientos-de-datos',
  AUTECO_MANUALS: 'http://manualesdigitales.autecomobility.com.co/',
  AUTECO_CONDITIONS: 'https://www.autecomobility.com/terminos-y-condiciones',
  AUTECO_SHOP: 'https://www.autecomobility.com/home-app',
  PRIVACITY_POL: 'https://policies.google.com/privacy',
  GOOGLE_TERMS: 'https://policies.google.com/terms',
  LOGO_MOBILITY:
    'https://3j1z6j2up0jr3r2zz2111ri2-wpengine.netdna-ssl.com/wp-content/uploads/2020/05/auteco-mobility-logo.png',
  LOGO_AUTECO:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Auteco_logo.svg/245px-Auteco_logo.svg.png',
  LOGO_HONDA:
    'https://e7.pngegg.com/pngimages/667/590/png-clipart-honda-logo-honda-motor-company-car-motorcycle-honda-angle-text.png',
  LOGO_YAMAHA:
    'https://i.pinimg.com/originals/5f/e6/f4/5fe6f4ae70c5ea5c41e83542b9e62f32.jpg',
  LOGO_HERO:
    'https://www.logolynx.com/images/logolynx/05/051f8eb45b58c1469afcb74a3b919c91.jpeg',
  LOGO_SUZUKI:
    'https://e7.pngegg.com/pngimages/63/759/png-clipart-suzuki-sx4-car-ford-mustang-suzuki-jimny-benz-logo-angle-text.png',
  DEFAULT_IMG:
    'https://3j1z6j2up0jr3r2zz2111ri2-wpengine.netdna-ssl.com/wp-content/uploads/2020/05/auteco-mobility-logo.png',
  MAP_LEAFLET:
    'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
  MAP_BEACONS: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
};
